import clsx from "clsx"
import { OverridableComponent } from "@mui/material/OverridableComponent"
import { SvgIconTypeMap } from "@mui/material"
import { ForwardRefExoticComponent, RefAttributes } from "react"
import { LucideProps } from "lucide-react"

export type LabelWithIconProps = {
  label: string
  Icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string } | ForwardRefExoticComponent<Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>>
  style?: {
    mainStyle?: string
    labelStyle?: string
    iconStyle?: string
  }
}

const LabelWithIcon = ({ label, Icon, style }: LabelWithIconProps) => {
  return (
    <div
      className={clsx("text-gray1 flex items-center", style?.mainStyle)}>
      <Icon size={20}/>
      <p
        className={clsx(
          "ml-2 text-lg font-semibold leading-[0px] text-sm",
          style?.labelStyle,
        )}>
        {label}
      </p>
    </div>
  )
}

export default LabelWithIcon
